var _rect, _rect2, _rect3, _rect4, _rect5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 63,
    height: 55,
    viewBox: "0 0 63 55",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    y: 3.79614,
    width: 6.89084,
    height: 50.6132,
    rx: 3.44542,
    fill: "#FA8B02"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 27.5625,
    y: 3.79614,
    width: 6.89084,
    height: 50.6132,
    rx: 3.44542,
    fill: "#FA8B02"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 55.125,
    y: 3.79614,
    width: 6.89084,
    height: 50.6132,
    rx: 3.44542,
    fill: "#FA8B02"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 13.7812,
    width: 6.89084,
    height: 50.6132,
    rx: 3.44542,
    fill: "#F1F3F6"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 41.3398,
    width: 6.89084,
    height: 50.6132,
    rx: 3.44542,
    fill: "#F1F3F6"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.bb3271344cce9467a47217f7ee5167dc.svg";
export { ForwardRef as ReactComponent };